import {cdnImage} from '@/util/cdnImage';
import {StaticImageData} from 'next/image';
const security = cdnImage('home-page-new/iso-27001.webp');
const quality = cdnImage('home-page-new/iso-9001.webp');
const business = cdnImage('home-page-new/BBB.webp');
const certik = cdnImage('home-page-new/certik.webp');
export interface CertificationBadge {
    src: StaticImageData | string;
    title: string;
    subtitle: string;
}

export const certificationBadges: CertificationBadge[] = [
    {src: quality, title: '9001:2015', subtitle: 'Quality Certified'},
    {src: security, title: 'ISO 27001', subtitle: 'Security Certified'},
    {src: business, title: 'A+ Rating', subtitle: 'Accredited Business'},
    {src: certik, title: 'Certik', subtitle: 'Security & Audit'}
];

export const footerDataContent = [
    {
        heading: 'Company',
        values: [
            {path: '/about-us', label: 'About Us'},
            {path: '/career', label: 'Career'},
            {path: '/portfolio', label: 'Portfolio'},
            {
                path: '',
                label: 'Resources',
                subChild: true,
                subChildItem: [
                    {path: '/blog', label: 'Blog'},
                    {path: '/use-cases', label: 'Use Cases'}
                ]
            }
        ]
    },
    {
        isMore: true,
        heading: 'Key Services',
        values: [
            {path: '/ai-development-company', label: 'Artificial Intelligence / ML'},
            {path: '/generative-ai-development-company', label: 'Generative AI Development'},
            {path: '/ai-agent-development-company', label: 'AI Agent Development'},
            {path: '/blockchain-development-services', label: 'Blockchain Development'},
            {path: '/cryptocurrency-exchange-development', label: 'Cryptocurrency Exchange'},
            {path: '/real-estate-tokenization', label: 'Real Estate Tokenization'},
            {path: '/real-world-asset-tokenization', label: 'RWA Tokenization'}
        ],
        more: [
            {path: '/crypto-wallet', label: 'Crypto Wallet Development'},
            {path: '/token-development-company', label: 'Token Development'},
            {path: '/mobile-application-development-services', label: 'Mobile App Development'},
            {path: '/web-development', label: 'Web Development'}
        ]
    },
    {
        heading: 'Industries',
        values: [
            {path: '/healthcare-app-development-company', label: 'Healthcare'},
            {path: '/fintech-software-development', label: 'Fintech'},
            {path: '/transport-logistics-software-development', label: 'Transport & Logistics'},
            {path: '/education-app-development-company', label: 'EdTech'},
            {path: '/on-demand-app-development', label: 'On Demand App'},
            {path: '/media-entertainment-software-development', label: 'Media & Entertainment'},
            {path: '/real-estate-software-development', label: 'Real Estate'}
        ]
    },
    {
        heading: 'Products',
        values: [
            {path: '/white-label-crypto-exchange-development', label: 'White Label Crypto Exchange'},
            {path: '/white-label-tokenization-platform-development', label: 'White Label Tokenization Platform'},
            {path: '/white-label-crypto-wallet', label: 'White Label Crypto Wallet'},
            {path: '/white-label-nft-marketplace', label: 'White label NFT marketplace'}
        ]
    },
    {
        isMore: true,
        heading: 'Portfolio',
        values: [
            {path: '/case-study/talentquest', label: 'TalentQuest Innovations'},
            {path: '/case-study/titletech', label: 'TitleTech Financial Solution'},
            {path: '/case-study/ifinca', label: 'ifinca'},
            {path: '/case-study/integraledger', label: 'Integra Ledger'},
            {path: '/case-study/lummid', label: 'Lummid Ai'},
            {path: '/case-study/wellpop', label: 'WellPOP'}
        ],
        more: [
            {path: '/case-study/ndax-ecosystem', label: 'NDAX'},
            {path: '/case-study/unique-school', label: 'Unique School'},
            {path: '/case-study/aithentic', label: 'Aithentic'}
        ]
    }
];
